/**
 * Constants for the discount flow.
 *
 * Copy lives here rather than in the views for the same reason the rules do: the POS modal, the
 * mobile sheet and the kiosk cart all report the same refusals, and three surfaces phrasing one
 * refusal three ways is how a cashier learns to distrust one of them.
 */

/** A partner refused an apply or a verify without naming a reason. */
export const OFFER_FAILED_KEY = "discount.offerFailed" as const;

/** The unblock call is missing the customer's phone number, which the partner requires. */
export const CUSTOMER_PHONE_MISSING_KEY = "discount.phoneMissing" as const;
